"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Wrench, TriangleAlert as AlertTriangle, ArrowRight } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
export default function Replacementpartsadvisory() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="replacementpartsadvisory" data-nav="light" className="bg-background text-foreground py-16 sm:py-20 md:py-24 border-b border-border">
      <div className="container mx-auto max-w-4xl px-4 sm:px-6">
        <motion.div initial={{
        opacity: 0,
        y: shouldReduceMotion ? 0 : 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }}>
          <Card className="rounded-none border border-border bg-card shadow-xs relative overflow-hidden py-0">
            {/* Top industrial decorative accent rule */}
            <div className="h-1 w-full bg-primary" />

            <CardContent className="p-6 sm:p-10 md:p-12">
              <div className="flex flex-col gap-6 sm:gap-8">
                <div className="flex flex-wrap items-center justify-between gap-3 border-b border-border/80 pb-5">
                  <div className="flex items-center gap-2">
                    <Badge variant="outline" className="rounded-none border-border bg-muted/60 text-foreground uppercase tracking-widest font-mono text-[11px] px-2.5 py-1 flex items-center gap-1.5">
                      <AlertTriangle className="size-3.5 text-primary" />
                      Equipment Advisory
                    </Badge>
                  </div>
                  <span className="font-mono text-xs text-muted-foreground uppercase tracking-wider flex items-center gap-1.5">
                    <Wrench className="size-3.5 text-muted-foreground" />
                    Spec Standard
                  </span>
                </div>

                <div className="space-y-4">
                  <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold uppercase tracking-tight text-foreground">
                    Replacement Parts and Accessories
                  </h2>

                  <div className="space-y-4 font-sans text-muted-foreground text-base sm:text-lg leading-relaxed max-w-3xl">
                    <p>
                      Parts availability is worth considering before buying a mechanical bull, especially for older equipment. Controllers, electrical components, blowers, inflatable components and other model-specific parts may not be interchangeable.
                    </p>
                    <p>
                      When replacing a component, identify the machine and existing part first. Do not assume that a similar-looking component will work with another model.
                    </p>
                  </div>
                </div>

                <div className="pt-2 sm:pt-4">
                  <Button asChild size="lg" className="rounded-none bg-primary text-primary-foreground hover:bg-primary/90 font-medium px-6 h-11 transition-[background-color,box-shadow]">
                    <Link to="/MechanicalBullPartsAndAccessoriesPage" className="inline-flex items-center gap-2">
                      <span>Shop Mechanical Bull Parts</span>
                      <ArrowRight className="size-4" />
                    </Link>
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </section>;
}